import { useState } from 'react'
import { Typography, Button } from '@mui/material'
import Edit from '@mui/icons-material/Edit'
import UserDataEditPopper from './UserDataEditPopper'
import { WorkUnitCellEditHandler, WorkUnitGridRow } from './WorkUnitTable'
import { asDisplayText } from '~/shared/lib/displayText'

interface EditableUserDataCellProps {
  field: string
  validValues?: string[] | undefined
  value: unknown
  worklistRowData: WorkUnitGridRow
  editable?: boolean
  handleOnEdit: WorkUnitCellEditHandler
}

const EditableUserDataCell = (props: EditableUserDataCellProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const currentValue = props.value
  const open = Boolean(anchorEl)

  const onEditClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const onPopperClose = () => {
    setAnchorEl(null)
  }

  return (
    <div
      style={{
        display: 'flex',
        flexFlow: 'row nowrap',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Typography>{asDisplayText(currentValue) || '-'}</Typography>
      {!(props.editable === false) && (
        <Button onClick={onEditClick}>
          <Edit titleAccess="Edit" />
        </Button>
      )}
      <UserDataEditPopper
        anchorEl={anchorEl}
        open={open}
        field={props.field}
        validValues={props.validValues}
        handleOnEdit={props.handleOnEdit}
        currentValue={currentValue}
        worklistRowData={props.worklistRowData}
        onClose={onPopperClose}
      />
    </div>
  )
}

export default EditableUserDataCell
